import {
    createLocaleTextWithDevI18nKey,
    getLocale,
    setLocale,
    useLocaleText,
    type LocaleTextPrinter,
} from '@meitu/xdesign-i18n';
import { localeTextMap, type LocaleCode, type LocaleText } from '../locales';

type LocaleStoreCache = Record<
    LocaleCode,
    {
        locale: LocaleCode;
        $t: LocaleTextPrinter<LocaleText>;
    }
>;
const localStoreCache: Partial<LocaleStoreCache> = {};

export const initLocaleStore = (locale: LocaleCode) => {
    setLocale(locale);
};

export const getLocaleStore = (_locale?: LocaleCode) => {
    const locale: LocaleCode = _locale || getLocale() || 'zh-Hans';
    const localeText = localeTextMap[locale] ?? localeTextMap['zh-Hans'];

    if (!localStoreCache[locale]) {
        localStoreCache[locale] = {
            locale,
            $t: createLocaleTextWithDevI18nKey(
                localeText as unknown as Record<string, unknown>,
                'saasColor',
            ) as unknown as LocaleTextPrinter<LocaleText>,
        };
    }

    return localStoreCache[locale]!;
};

export const useLocaleStore = () => {
    const locale = useLocaleText<LocaleCode>();

    return getLocaleStore(locale);
};
